module.exports = __webpack_public_path__ + "static/img/case4.cffb911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case4.png
// module id = 8Jw5
// module chunks = 3